import { render, staticRenderFns } from "./myAddr.vue?vue&type=template&id=4784db62&scoped=true"
import script from "./myAddr.vue?vue&type=script&lang=js"
export * from "./myAddr.vue?vue&type=script&lang=js"
import style0 from "./myAddr.vue?vue&type=style&index=0&id=4784db62&prod&lang=scss"
import style1 from "./myAddr.vue?vue&type=style&index=1&id=4784db62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784db62",
  null
  
)

export default component.exports